import React, { useCallback } from 'react';
import PropTypes from "prop-types";
import {
    AdvancedMarker,
    AdvancedMarkerAnchorPoint,
    useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { RouteurWifi } from 'components/CustomIcon/CustomIcon';

export default function FeatureMarker(props) {
    const {
        position,
        featureId,
        onMarkerClick,
        properties
    } = props;

    const [markerRef, marker] = useAdvancedMarkerRef();
    const handleClick = useCallback(
        () => onMarkerClick && onMarkerClick(marker, featureId),
        [onMarkerClick, marker, featureId]
    );

    return (
        <AdvancedMarker
            ref={markerRef}
            position={position}
            onClick={handleClick}
            anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
            className={'marker feature'}
            style={{background:properties.status === 'ok' ? '#91C73C' : properties.status === 'ko' ? '#f44336' : '#605f70'}}>

            <RouteurWifi 
                style={{color:"#FFFFFF"}}
            />
        </AdvancedMarker>
    );
}

